import { string } from "prop-types";

const AmsterdamOost = ({ className }) => (
  <>
    <path
      d="M591 540.307L639.097 560.953L648.219 550.63L640.756 500.665L653.195 494.884L636.211 456.721L625 463.501L620.024 480.844L599.293 489.929V506.446L591 540.307Z"
      fill="url(#paint11_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M617.535 369.352L630.389 359.855L659.413 354.073L683.462 330.949H768.851V337.094L756.205 349.688V361.506H773.022V369.352H719.526L636.426 418.681L617.535 369.352Z"
      fill="url(#paint12_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M773.022 369.352L806.193 381.327L752.291 463.087L732.388 473.824L661.768 444.918L650.059 454.432L636.426 418.681L719.526 369.352H773.022Z"
      fill="url(#paint13_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M653.194 494.885L689.317 473.825L710.414 483.323L732.389 473.825L661.769 444.92L650.06 454.434L648.219 449.462L636.211 456.722L653.194 494.885Z"
      fill="url(#paint14_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M777.999 264.055L769.706 273.139C769.706 273.139 768.047 320.304 769.706 320.304H806.194V330.95L815.058 338.432L823.376 330.149V319.611H836.827L777.99 264.055H777.999Z"
      fill="url(#paint15_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M895.132 444.92L810.547 374.82H858.23L852.839 381.873L892.022 418.682V425.239L906.12 439.23L895.132 444.92Z"
      fill="url(#paint16_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M862.586 381.328L923.429 436.438L942.9 421.589L929.325 400.059L936.805 392.362L929.325 387.464L923.429 393.766L875.025 354.9L862.586 365.083L871.476 376.786L862.586 381.328Z"
      fill="url(#paint17_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
  </>
);

AmsterdamOost.propTypes = {
  className: string,
};

export default AmsterdamOost;
